import React from 'react'

import DiagnosticoAposentadoriaIndependenciaFinanceiraChart from './DiagnosticoAposentadoriaIndependenciaFinanceiraChart'



const DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart = ( { values, setFieldValue, estudo, report,
    naoExibirCapacidadePoupanca, naoExibirGrafico, moreLessList, aiFT } ) => {

    return (
        <DiagnosticoAposentadoriaIndependenciaFinanceiraChart
            values={values}
            setFieldValue={setFieldValue}
            estudo={estudo}
            graficoIndependenciaFinanceiraSituacaoAtualSuperavit={estudo.current.graficoIndependenciaFinanceiraSituacaoAtualSuperavit}
            graficoIndependenciaFinanceiraSituacaoAtualDeficit={estudo.current.graficoIndependenciaFinanceiraSituacaoAtualDeficit}
            valorRetiradaMensalMaximaConsumirReservaAposentadoria={values.valorRetiradaMensalMaximaConsumirReservaAposentadoria}
            graficoIndependenciaFinanceiraConsumirReservaAposentadoria={estudo.current.graficoIndependenciaFinanceiraConsumirReservaAposentadoria}
            valorRetiradaMensalMaximaPreservarReservaAposentadoria={values.valorRetiradaMensalMaximaPreservarReservaAposentadoria}
            graficoIndependenciaFinanceiraPreservarReservaAposentadoria={estudo.current.graficoIndependenciaFinanceiraPreservarReservaAposentadoria}
            valorPresenteDeficitSimulacaoMensal={values.valorPresenteDeficitSimulacaoMensal}
            graficoIndependenciaFinanceiraSituacaoIdeal={estudo.current.graficoIndependenciaFinanceiraSituacaoIdeal}
            valorAporteMensalPreservarReservaAposentadoria={values.valorAporteMensalPreservarReservaAposentadoria}
            graficoIndependenciaFinanceiraViverRentabilidade={estudo.current.graficoIndependenciaFinanceiraViverRentabilidade}
            valorPresenteDeficitReservaInicioAposentadoria={values.valorPresenteDeficitReservaInicioAposentadoria}
            valorDepositoUnicoManterPadraoVida={values.valorDepositoUnicoManterPadraoVida}
            valorDepositoUnicoViverRentabilidade={values.valorDepositoUnicoViverRentabilidade}
            necessidadeAposentadoria={values.necessidadeAposentadoria}
            necessidadeAposentadoriaLimiteReserva={values.necessidadeAposentadoriaLimiteReserva}
            valorDepositoViverRentabilidadeSaldoInicioAposentadoria={values.valorDepositoViverRentabilidadeSaldoInicioAposentadoria}
            valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria={
                values.valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria
            }
            //valorSaldoFinalSituacaoAtual={values.valorSaldoFinalSituacaoAtual}
            valorPresenteReservaInicioAposentadoria={values.valorPresenteReservaInicioAposentadoria}
            valorPresenteNecessidadesInicioAposentadoria={values.valorPresenteNecessidadesInicioAposentadoria}
            report={report}
            popup={false}
            simulacaoFinanceira={false}
            naoExibirCapacidadePoupanca={naoExibirCapacidadePoupanca}
            naoExibirGrafico={naoExibirGrafico}
            moreLessList={moreLessList}
            aiFT={aiFT}
        />
    )
}

export default DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart